import React, { memo } from 'react';
import { Activity } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { PaneShell, PaneEmpty } from './PaneShell';
import { cn } from '../../lib/utils';

/**
 * PulsePane — what changed, most recent first.
 *
 * Entries arrive pre-merged and pre-keyed from Home; the old version keyed rows
 * by array index over a list that reorders on every single mutation, so React
 * reconciled the wrong rows every time a task was touched.
 */

const DOT = {
    task: 'bg-green-500',
    file: 'bg-primary',
};

function PulsePaneImpl({ activity, onOpen }) {
    return (
        <PaneShell icon={Activity} label="Pulse" accent="text-accent">
            {activity.length === 0 ? (
                <PaneEmpty icon={Activity} title="No activity yet" />
            ) : (
                <div className="cv-auto divide-y divide-white/[0.04]">
                    {activity.map((entry) => (
                        <button
                            key={entry.key}
                            type="button"
                            onClick={() => onOpen(entry)}
                            className="group flex w-full items-center gap-2.5 px-3 py-2 text-left transition-colors hover:bg-white/[0.03]"
                        >
                            <span className={cn('h-1.5 w-1.5 flex-shrink-0 rounded-full', DOT[entry.type])} />
                            <span className="min-w-0 flex-1 truncate text-xs transition-colors group-hover:text-primary">
                                {entry.label}
                            </span>
                            <span className="flex-shrink-0 whitespace-nowrap text-[10px] tabular-nums text-muted-foreground/70">
                                {formatDistanceToNow(entry.date)}
                            </span>
                        </button>
                    ))}
                </div>
            )}
        </PaneShell>
    );
}

export const PulsePane = memo(PulsePaneImpl);
export default PulsePane;
